import React from 'react';
import {ChevronLeftIcon} from "@heroicons/react/solid";
import {useNavigate} from "react-router-dom";
import Breadcrumb from "components/Breadcrumb";

type Crumb = {
    name: string
    path: string
    isFirst?: boolean
}

type Props = {
    children: Array<Crumb>
}

function BreadcrumbNav(props: Props) {
    const {children} = props
    const navigate = useNavigate()

    return (
        <div>
            {/* Back (mobile only) */}
            <nav className="sm:hidden" aria-label="Back">
                <button onClick={() => navigate(-1)} className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                    <ChevronLeftIcon className="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                    Back
                </button>
            </nav>

            {/* Full breadcrumbs (Small+) */}
            <nav className="hidden sm:flex" aria-label="Breadcrumb">
                <ol className="flex items-center space-x-4">
                    {children.map((crumb) => (
                        <Breadcrumb key={crumb.name} {...crumb} />
                    ))}
                </ol>
            </nav>
        </div>
    );
}

export default BreadcrumbNav;